<!-- 
<nav class="nav padd-t-2 padd-m-t-2">
  <div class="row verticalalign inlinemob">
      <div class="col-md-auto nav-logo-mob">
          <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 245.179 113.055"><g  id="Capa_2" data-name="Capa 2"><g  id="Capa_1-2" data-name="Capa 1"><g  id="Logotipo"><g  id="Tipografía"><path  d="M87.511,71.978c-1.124-3.747-4.259-4.848-9.226-4.244a1.614,1.614,0,0,0-1.415,1.6v5.337c2.574-.292,3.625.293,3.625,2.983V96.127h8.187V81.92c0-4.8,2.981-7.076,6.374-7.076a8.589,8.589,0,0,1,4.618,1.227l2.749-6.84a12.776,12.776,0,0,0-6.667-1.813A9.7,9.7,0,0,0,87.511,71.978Z" class="cls-2"></path><path  d="M106.532,69.548v26.58h8.184V67.944h-6.58A1.6,1.6,0,0,0,106.532,69.548Z" class="cls-2"></path><path  d="M110.684,55.2c-2.866,0-4.913,1.754-4.913,4.5s2.047,4.561,4.913,4.561a4.453,4.453,0,0,0,4.793-4.561C115.477,56.952,113.489,55.2,110.684,55.2Z" class="cls-2"></path><path  d="M138.066,67.36a12.531,12.531,0,0,0-8.421,2.924V55.2h-6.582a1.6,1.6,0,0,0-1.6,1.6V94.49a34.733,34.733,0,0,0,12.221,2.223c9.531,0,17.249-4.445,17.249-15.32C150.929,71.57,144.964,67.36,138.066,67.36Zm-3.215,22.454a19.125,19.125,0,0,1-5.206-.644V82.037c0-4.62,2.047-7.779,6.723-7.779,4.037,0,6.55,2.691,6.55,7.428C142.918,87.24,139.644,89.814,134.851,89.814Z" class="cls-2"></path><path  d="M182.17,76.365c0-5.555-4.679-9.006-12.163-9.006-7.718,0-15.5,4.561-15.5,14.677,0,9.357,6.608,14.676,15.729,14.676A24.883,24.883,0,0,0,180.25,94.84a1.615,1.615,0,0,0,.94-1.887l-1.184-4.6a20.642,20.642,0,0,1-8.772,1.637c-3.683,0-6.84-1.228-8.126-4.562,1.11.059,2.162.059,3.157.059C176.381,85.486,182.17,83.088,182.17,76.365Zm-19.53,3.8c.525-3.917,3.1-6.549,7.191-6.549,2.749,0,4.505,1.112,4.505,3.1,0,2.454-2.575,3.566-8.656,3.566C164.745,80.282,163.75,80.224,162.64,80.165Z" class="cls-2"></path><path  d="M195.694,71.978c-1.125-3.747-4.261-4.848-9.228-4.244a1.613,1.613,0,0,0-1.414,1.6v5.337c2.573-.292,3.626.293,3.626,2.983V96.127h8.185V81.92c0-4.8,2.983-7.076,6.374-7.076a8.589,8.589,0,0,1,4.618,1.227l2.749-6.84a12.768,12.768,0,0,0-6.667-1.813A9.7,9.7,0,0,0,195.694,71.978Z" class="cls-2"></path><path  d="M241.554,86.011V70.785a1.6,1.6,0,0,0-1.083-1.518,34.98,34.98,0,0,0-11.2-1.907c-9.708,0-17.249,4.852-17.249,15.26,0,8.948,5.321,14.093,13.039,14.093,4.034,0,7.484-1.579,9.415-4.5,1.518,4.618,7.192,4.676,10.7,3.915V89.4C242.02,89.7,241.554,88.587,241.554,86.011ZM233.367,81.8c0,5.028-2.222,7.952-6.666,7.952-4.033,0-6.6-2.746-6.606-7.363a8.279,8.279,0,0,1,8.248-8.131,18.685,18.685,0,0,1,5.024.524Z" class="cls-2"></path></g><g  id="Árbol"><path  d="M37.5,55.231a26.065,26.065,0,0,0-2.314-9.961c-2.112-4.551-6.641-10.1-16.228-10.683a20.477,20.477,0,0,0-8.631,1.485,4.872,4.872,0,0,1-3.718.111,4.48,4.48,0,0,1-2.224-2.558,3,3,0,0,1,.433-3.271,2.434,2.434,0,0,1,2.151-.876,1.178,1.178,0,0,1,.8.487,1.817,1.817,0,0,1,.009,1.155,2.05,2.05,0,0,0,3.665,1.836,5.821,5.821,0,0,0,.077-4.643A5.018,5.018,0,0,0,8,25.512a6.5,6.5,0,0,0-6.223,2.1,7.023,7.023,0,0,0-1.25,7.38,8.587,8.587,0,0,0,4.236,4.839A16.7,16.7,0,0,0,.448,48.3,17.538,17.538,0,0,0,3.826,61.6a14.316,14.316,0,0,0,11.043,5.083c7.885,0,11.122-4.591,12.347-7.321.059-.123.116-.246.17-.369.014-.031.026-.062.039-.093.039-.092.079-.184.115-.277.015-.037.028-.074.042-.111.033-.086.066-.172.1-.258.014-.039.026-.078.039-.118.028-.083.057-.167.083-.25.013-.039.023-.079.035-.118.025-.083.05-.166.073-.249.011-.04.02-.079.03-.119.022-.082.044-.164.063-.246.009-.038.017-.077.026-.115.018-.083.037-.165.054-.248.007-.035.013-.069.02-.1.016-.086.033-.171.047-.255.006-.034.011-.067.016-.1.014-.085.028-.17.039-.255,0-.034.009-.068.013-.1.011-.084.022-.167.031-.249,0-.034.006-.066.01-.1.008-.083.016-.166.023-.248,0-.033,0-.066.007-.1.006-.081.011-.162.016-.242,0-.032,0-.064,0-.1,0-.08.007-.161.009-.24,0-.03,0-.06,0-.09,0-.08,0-.16,0-.239,0-.03,0-.059,0-.088q0-.119,0-.234c0-.03,0-.058,0-.087,0-.077-.005-.153-.008-.228,0-.029,0-.057,0-.085,0-.074-.008-.148-.013-.22,0-.031-.005-.06-.007-.09,0-.07-.01-.14-.016-.208l-.009-.085c-.006-.068-.013-.137-.02-.2,0-.03-.007-.058-.011-.088-.007-.064-.014-.128-.023-.19l-.012-.092c-.008-.059-.016-.118-.025-.175l-.015-.094c-.008-.055-.017-.11-.026-.163,0-.032-.011-.063-.017-.095-.008-.051-.017-.1-.026-.15-.006-.033-.013-.064-.019-.1s-.017-.093-.027-.137-.013-.064-.02-.1-.017-.084-.026-.124-.015-.068-.023-.1-.016-.071-.024-.105-.017-.072-.026-.107l-.021-.086-.028-.109-.018-.07-.031-.112-.014-.051c-.012-.04-.023-.078-.033-.115l-.01-.033c-.012-.041-.024-.079-.035-.116l0-.017c-.015-.049-.03-.1-.043-.136a10.412,10.412,0,0,0-8.613-7.11l-.127-.012c-4.275-.235-7.461,1.687-8.956,5.438a7.443,7.443,0,0,0,.641,6.8,7.183,7.183,0,0,0,6.119,3.029h.02a2.05,2.05,0,0,0,.037-4.1,3.147,3.147,0,0,1-2.768-1.207,3.4,3.4,0,0,1-.242-3.006c.816-2.046,2.409-2.987,4.845-2.868a6.271,6.271,0,0,1,5.1,4.156l.037.12a8.862,8.862,0,0,1-.271,6.2,8.374,8.374,0,0,1-1.538,2.321h0c-.166.176-.345.347-.535.513l-.043.037c-.087.074-.175.147-.266.219l-.026.021c-.1.08-.21.159-.32.235l-.006,0c-.1.071-.207.14-.315.207l-.07.044c-.1.058-.192.115-.292.17l-.06.034c-.121.066-.246.13-.374.191l-.021.01c-.116.056-.237.109-.359.16l-.1.042c-.105.043-.211.083-.32.123l-.1.036c-.141.049-.284.1-.432.139l-.033.009c-.135.04-.273.076-.414.111l-.133.031c-.117.027-.235.052-.355.076l-.135.026c-.162.03-.328.057-.5.08l-.03,0c-.16.021-.323.039-.489.055l-.162.014c-.132.01-.266.019-.4.026l-.166.008c-.188.008-.378.013-.574.013A10.133,10.133,0,0,1,7,59.015a13.333,13.333,0,0,1-2.53-9.956c.008-.038.016-.079.026-.123.028-.128.064-.281.109-.454l0-.018a14.407,14.407,0,0,1,1.167-3l0-.006c.052-.1.105-.2.16-.3l0,0c.055-.1.111-.2.17-.3l0-.007c.056-.095.114-.191.174-.287l.012-.019c.059-.094.119-.188.181-.281l.017-.027c.062-.092.126-.185.19-.277l.021-.031c.064-.09.13-.18.2-.27l.028-.038c.066-.088.135-.176.2-.263l.034-.044c.068-.085.139-.17.211-.255l.041-.05c.07-.082.143-.164.217-.246l.049-.056c.073-.08.149-.159.225-.238l.056-.06c.076-.077.154-.154.232-.23l.064-.063c.078-.075.158-.148.239-.221.025-.022.048-.045.072-.067.08-.071.162-.14.244-.21l.084-.071c.081-.067.165-.133.249-.2.032-.025.062-.05.1-.075.083-.064.169-.126.255-.188.035-.026.069-.052.105-.077.084-.06.172-.119.26-.177.05-.034.1-.068.149-.1l.068-.045.129-.081a11.959,11.959,0,0,1,4.611-1.707,17.775,17.775,0,0,1,3.913-.226c.156.01.308.023.461.036h0c13.671,1.138,14.182,14.954,14.2,16.393V70.1c-.01,1.165-.26,8.075-4.527,9.552a6.99,6.99,0,0,1-5.8-.866,5.37,5.37,0,0,1-2.346-3.64,3.05,3.05,0,0,1,.706-2.511,2.581,2.581,0,0,1,2.515-.764,2.261,2.261,0,0,1,1.537,1.792,2.049,2.049,0,1,0,3.99-.934,6.355,6.355,0,0,0-4.4-4.8,6.7,6.7,0,0,0-6.532,1.792A7.115,7.115,0,0,0,16.66,75.65a9.524,9.524,0,0,0,4.09,6.513A10.666,10.666,0,0,0,26.839,84a12.928,12.928,0,0,0,3.1-.388l.146-.041A8.943,8.943,0,0,0,33.4,81.6V94.862a2.049,2.049,0,1,0,4.1,0V70.5c.009-.391,0-.645,0-.707Z" class="cls-2"></path><path  d="M15.011,27.22c2.151,1.3,5.739,2.419,10.624.308l.151-.074a7.627,7.627,0,0,0,3.684-4.6,8.52,8.52,0,0,0-.875-7.15,6.085,6.085,0,0,0-3.275-2.473,7.418,7.418,0,0,0-5.843.515,5.092,5.092,0,0,0-2.5,3.214,2.052,2.052,0,0,0,1.526,2.464A2.049,2.049,0,0,0,20.972,17.9a1.093,1.093,0,0,1,.552-.6,3.332,3.332,0,0,1,2.606-.145,2.021,2.021,0,0,1,1.076.855,4.485,4.485,0,0,1,.348,3.64A3.533,3.533,0,0,1,23.923,23.8c-2.594,1.1-4.876,1.072-6.787-.088a7.418,7.418,0,0,1-3.384-5.134,9.445,9.445,0,0,1,2.111-6.9c1.583-1.739,4.055-2.62,7.288-2.591,8.074.588,9.972,6.422,10.142,11.205L33.3,36.653a2.049,2.049,0,1,0,4.1,0V20.414l-.01-.262C37.066,11.118,31.962,5.594,23.379,5l-.112,0c-.1,0-.194,0-.291,0-4.355,0-7.766,1.321-10.142,3.928A13.443,13.443,0,0,0,9.671,18.947,11.362,11.362,0,0,0,15.011,27.22Z" class="cls-2"></path><path  d="M63.549,58.826a11.322,11.322,0,0,0-10.622-.319l-.113.056a8.1,8.1,0,0,0-3.858,4.568A9.425,9.425,0,0,0,50.015,71a6.072,6.072,0,0,0,3.311,2.488,7.294,7.294,0,0,0,6.247-.631A6.046,6.046,0,0,0,62.1,68.072a2.049,2.049,0,0,0-1.889-2.2,1.985,1.985,0,0,0-1.49.488,2.023,2.023,0,0,0-.707,1.4,2.167,2.167,0,0,1-.753,1.717,3.377,3.377,0,0,1-2.745.091,2.046,2.046,0,0,1-1.152-.931,5.411,5.411,0,0,1-.507-4.244,3.96,3.96,0,0,1,1.84-2.191,7.183,7.183,0,0,1,6.81.175,7.361,7.361,0,0,1,3.642,5.315,9.3,9.3,0,0,1-2.1,6.751c-1.6,1.782-4.066,2.693-7.307,2.706-8.055-.59-9.957-6.4-10.133-11.161l-.011-14.075h-.021a2.037,2.037,0,0,0-4.058,0h-.019V94.862a2.048,2.048,0,1,0,4.1,0V77.005a14.762,14.762,0,0,0,9.931,4.238l.135.005c4.5,0,8.007-1.367,10.434-4.062a13.386,13.386,0,0,0,3.132-9.907A11.456,11.456,0,0,0,63.549,58.826Z" class="cls-2"></path><path  d="M75.969,24.932a16.543,16.543,0,0,0-12.951-3.2,13.038,13.038,0,0,0-9.226,5.882c-2.549,4.576-2.537,9.656.03,13.59a10.569,10.569,0,0,0,9.8,4.921c7.357-.564,8.923-6.123,8.723-8.984A6.468,6.468,0,0,0,68.69,31.76a7.405,7.405,0,0,0-7.332.5,2.049,2.049,0,1,0,2.263,3.416,3.3,3.3,0,0,1,3.258-.235,2.367,2.367,0,0,1,1.379,1.988c.03.431.143,4.22-4.986,4.615a6.543,6.543,0,0,1-6.017-3.079,8.655,8.655,0,0,1,6.436-13.19,12.455,12.455,0,0,1,9.625,2.284c3.446,3.011,5.673,9.236,2.422,15.783-2.213,4.126-6.817,6.225-10.087,6.769a17.087,17.087,0,0,1-9.441-1.055l-.845-.389c-6.33-2.9-8.647-9.074-9.478-13.749a60.619,60.619,0,0,1-.306-8.6l.01-14.111a9.946,9.946,0,0,1,2.628-6.344L48.3,6.27c1.661-1.876,6.093-2.953,9.538-1.59,2.722,1.08,4.057,3.379,3.969,6.82a5.49,5.49,0,0,1-5.463,5.192l-.04,0a5.42,5.42,0,0,1-3.345-1.167,2.519,2.519,0,0,1-.692-1.865,2.023,2.023,0,0,1,1.084-1.979,2.21,2.21,0,0,1,1.7-.005,2.049,2.049,0,0,0,3.318-2.4C57.293,7.7,54.763,7,52.484,7.648a6.044,6.044,0,0,0-4.311,5.888,6.646,6.646,0,0,0,1.89,4.885,9.463,9.463,0,0,0,6.337,2.37,9.611,9.611,0,0,0,9.494-8.96L65.9,11.7c.156-5.173-2.233-9.121-6.554-10.83C54.671-.982,48.225.226,45.28,3.5a14.162,14.162,0,0,0-3.787,9.2l-.008,14.073c-.014.724-.122,7.135.383,9.438,1.335,7.529,5.035,13.109,10.7,16.14l1.045.525a20.725,20.725,0,0,0,9.1,2.076,22.15,22.15,0,0,0,3.607-.3c4.386-.732,10.119-3.461,13.053-8.933C83.616,37.184,80.584,28.962,75.969,24.932Z" class="cls-2"></path></g></g></g></g></svg>
      </div>
      <div class="col col-items nomob">
          <div class="wrapper itemsNav">
              <div class="linksplitscrolla item white" ><a class="lateanimate nav-campana"><div class="splita">Campaña</div></a></div>
              <div class="linksplitscrolla item white" ><a class="lateanimate nav-consejos"><div class="splita">Consejos</div></a></div>
              <div class="linksplitscrolla item white" ><a class="lateanimate nav-unete"><div class="splita">Únete</div></a></div>
              <div class="linksplitscrolla item white" ><a class="lateanimate nav-exposicion"><div class="splita">Exposiciones</div></a></div>
            </div>
      </div>
  </div>
</nav>


<div id="video" class="video01">
  <div class="row theclosser">
    <div class="col">
      <main >
        <a onclick="closevideolayer()" class="magnetic-wrap size1 an02">
          <div class="js-magnetic-area magnetic-size"></div>
            <div class="js-magnetic-content">
              <div class="my-burger">             
                <div id="hamburger">
                  <div id="menu" class="activenav">
                      <div id="pencet2">
                        <span class="fst"></span>
                        <span class="scnd"></span>
                      </div>
                    </div>
              </div>
            </div>
          </div>
        </a>
      </main>

    </div>
  </div>
  <div class="container videocontainer">
    <div class="row">
      <div class="col" id="video-container">       
        <iframe loading="lazy" id="vimeovideo" src="https://www.youtube.com/embed/_19fE8ppo5Y" title="Video" width="100%" height="564" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
       </div>
    </div>
  </div>
</div>

<div class="relative" data-scroll-container>

<div class="section1 container relative fluid wbg">

  <div class="section1-b container" >
    <div class="row">
      <div class="col m-w-450 auto-mobile mobile-fix">
        <div class="wrapper wrapper1 ">
          <img class="logo" src="assets/logo-ritmosdevida.png">
          <p class="padd-b-3 padd-t-1 historia">Conoce la historia del primer <span class="italic bold">metrónomo arrítmico</span> del mundo que interpreta la frecuencia cardíaca de una persona con una enfermedad cardiovascular.</p>
          <div class="containerbuton linksplitscrolla scaled">
            <a class="campana-btn">
              <div class="btn">
                <div class="left">
                  <div class=" item white" ><div class="splita">Descubre la campaña</div></div>
                </div>
                <div class="right">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.328 16.328"><g id="Capa_2" data-name="Capa 2"><g id="Capa_1-2" data-name="Capa 1"><path class="cls-1" d="M15.855,0H5.823a.473.473,0,1,0,0,.946h8.89L.139,15.52a.473.473,0,0,0,.668.669L15.382,1.614V10.5a.473.473,0,1,0,.946,0V.473A.473.473,0,0,0,15.855,0Z"></path></g></g></svg>
                </div>
              </div>
            </a>            
          </div>
        </div>
      </div>
    </div>
  </div>
  
</div>









<div class="section2_b relative" id="video-section">
  <div class="wrapper">
    <div class="box-image mainvideo opacity0">
      <div class="over overv1"></div>
      <main>
            <a onclick="videolayer('https:/\/\www.youtube.com/embed/Ze4s1zvlqEU')" class="magnetic-wrap size1 an02 ">
              <div class="js-magnetic-area magnetic-size"></div>
              <div class="js-magnetic-content">
                <div class="playbutton">
                  <div class="svgwrapper">
                    <svg class="arrow01" width="70px" height="70px" version="1.1" viewBox="0 0 600 580" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="m592.74 280-485.48-280v560z"/></svg>
                  </div>
                </div>
              </div>
            </a>
      </main>
    </div>
  </div>
</div>

<div class="section3 wbg lines padd-t-4 padd-b-4" id="campaign">
  <div class="wrapper container aligncenter">
    <div class="wrapper">
      <div class="row">
        <div class="col">
          <div class="wrapper m-w-800">
            <div class="pretitle padd-b-1">Campaña</div>
            <h2 class="grey">Ritmos <span class="de-vida">de</span> vida</h2>  
            <p class="m-w-550 auto padd-t-2 padd-b-2">
              Las enfermedades cardiovasculares son la principal causa de muerte en el mundo. A día de hoy, fallecen más de 17 millones de personas al año y se estima que en 2030 se alcancen los 23 millones. Concretamente en España, mueren 350 personas al día. <b>Un problema de salud, cada vez más frecuente en nuestra sociedad, que exige una mayor concienciación y cuidado por parte de todos</b>.
              <br/><br/>
              Desde el grupo sanitario Ribera tenemos la responsabilidad de ayudar a difundir el problema y conseguir concienciar a la sociedad. Para ello, hemos encontrado un dato clave como eje creativo de la campaña: <b>los latidos del corazón se miden igual que el tempo de las canciones, utilizando BPM (Beats Per Minute)</b>.
              <br/><br/>
              Así nace Ritmos de Vida, una campaña de concienciación basada en la fabricación del primer metrónomo de la historia que no sigue un tempo fijo, sino que se altera de la misma forma que las frecuencias cardíacas de Adrián, paciente que sufre una enfermedad cardiovascular.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="section4 padd-t-4 padd-b-4" id="tips">
  <div class="wrapper container aligncenter">
    <div class="wrapper">
      <div class="row">
        <div class="col">
          <div class="wrapper m-w-800">
            <div class="pretitle padd-b-1">CONSEJOS</div>
            <h2 class="grey">CON EL CORAZÓN, NO VALE LA IMPROVISACIÓN</h2>  
            <p class="m-w-550 auto padd-t-2 padd-b-2 padd-m-t-1">
              Aquí te dejamos algunas recomendaciones para seguir una vida saludable y, sobre todo, para cuidar tu corazón.
            </p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          
          <div class="carousel">


            <div class="module padd-t-5 padd-b-1 padd-m-t-0">
              <div class="container fullwidth ">
                <div class="wrapper relative">
  
                  <div class="absoluteClose projectSlider right">
                    <div class="liquidclose black close ">
                      <main><a class="liquidclose-wrap close size1 button--next">
                        <div class="js-magnetic-area liquid-size"></div>
                        <div class="js-magnetic-content">
                          <div class="circleB"></div>
                          <div class="circle">

                            <svg height="800px" width="800px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 227.10 227.10" xml:space="preserve" fill="#000000" stroke="#000000" stroke-width="11.354800000000001">
                              <g id="SVGRepo_bgCarrier" stroke-width="0"/>
                              <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#CCCCCC" stroke-width="4.087728"/>
                              <g id="SVGRepo_iconCarrier"> <g> <g> <polygon style="fill:#010002;" points="152.835,39.285 146.933,45.183 211.113,109.373 0,109.373 0,117.723 211.124,117.723 146.933,181.902 152.835,187.811 227.096,113.55 "/> </g> </g> </g>
                            </svg>
                            
                          </div>
                        </div></a></main>    
                    </div>
                  </div>
        
  
  
                  <div class="absoluteClose projectSlider left">
                    <div class="liquidclose black close ">
                      <main><a class="liquidclose-wrap close size1 button--previous">
                        <div class="js-magnetic-area liquid-size"></div>
                        <div class="js-magnetic-content">
                          <div class="circleB"></div>
                          <div class="circle arrow02">

                            <svg height="800px" width="800px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 227.10 227.10" xml:space="preserve" fill="#000000" stroke="#000000" stroke-width="11.354800000000001">
                              <g id="SVGRepo_bgCarrier" stroke-width="0"/>
                              <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#CCCCCC" stroke-width="4.087728"/>
                              <g id="SVGRepo_iconCarrier"> <g> <g> <polygon style="fill:#010002;" points="152.835,39.285 146.933,45.183 211.113,109.373 0,109.373 0,117.723 211.124,117.723 146.933,181.902 152.835,187.811 227.096,113.55 "/> </g> </g> </g>
                            </svg>

                          </div>
                        </div></a></main>    
                    </div>
                  </div>
        
  
                  <div class="slider">
                    <div class="slideshow js-slideshow">
  
                      <div class="slide slide1 wbg">
                        <div class="wrapper">
                          <div class="modulebg"></div>
                          <div class="moduletext">
                            <h3>Ejercítate</h3>
                            <p>
                              Solo 30 minutos, 5 días a la semana, reducen el riesgo de sufrir diabetes o tener un infarto.
                            </p>
                          </div>
                        </div>
                      </div>
                            
                      <div class="slide slide2 wbg">
                        <div class="wrapper">
                          <div class="modulebg"></div>
                          <div class="moduletext">
                            <h3>Come mejor</h3>
                            <p>
                              Prioriza las comidas en fibras y proteínas, así como el consumo de frutas y verduras.
                            </p>
                          </div>
                        </div>
                      </div>
                            
                      <div class="slide slide3 wbg">
                        <div class="wrapper">
                          <div class="modulebg"></div>
                          <div class="moduletext">
                            <h3>Pierde peso</h3>
                            <p>
                              Si tu índice de masa corporal es mayor de 25 debes empezar a preocuparte. Si es mayor de 30 estás expuesto a un riesgo alto de problemas cardiovasculares. 
                            </p>
                          </div>
                        </div>
                      </div>
                            
                      <div class="slide slide4 wbg">
                        <div class="wrapper">
                          <div class="modulebg"></div>
                          <div class="moduletext">
                            <h3>No fumes</h3>
                            <p>
                              Fumar daña el sistema circulatorio, aumenta el riesgo de aneurismas y enfermedades cardiacas. Fomenta la aparición de coágulos en la sangre.
                            </p>
                          </div>
                        </div>
                      </div>

                      <div class="slide slide5 wbg">
                        <div class="wrapper">
                          <div class="modulebg"></div>
                          <div class="moduletext">
                            <h3>Controla tu colesterol</h3>
                            <p>
                              Debes empezar a preocuparte si tu nivel de colesterol es superior a 200 mg/dl. 
                            </p>
                          </div>
                        </div>
                      </div>

                      <div class="slide slide6 wbg">
                        <div class="wrapper">
                          <div class="modulebg"></div>
                          <div class="moduletext">
                            <h3>Controla tu presión arterial</h3>
                            <p>
                              Si te mantienes en niveles normales favorecerás un buen estado de tu corazón, arterias y riñones. 
                            </p>
                          </div>
                        </div>
                      </div>
                            
                      <div class="slide slide7 wbg">
                        <div class="wrapper">
                          <div class="modulebg"></div>
                          <div class="moduletext">
                            <h3>Reduce tu nivel de azúcar en sangre</h3>
                            <p>
                              Mantén un nivel de glucosa normal (menos de 100 mg/dl) para proteger tus órganos vitales. 
                            </p>
                          </div>
                        </div>
                      </div>
                                                        
                            
                    </div>
  
                  </div>
                </div>
                <div class="wrapper">
                  <div class="indicator padd-t-2 padd-t-m-0"><div class="sidenavitem"><div class="underlink underlink1 black"></div><div class="under1" style="transform-origin: 100% 50%; transform: scale(0, 1); opacity: 1; color: rgb(153, 153, 153);"></div><div class="underdown1" style="transform-origin: 0% 50%; transform: translate(0px, 0px); opacity: 1;"></div></div></div>
                </div>
              </div>  
            </div>
  


          </div>
          

        </div>
      </div>
      <div class="row padd-t-4">
        <div class="col ">
          <div class="containerbuton linksplitscrolla aligncenter scaled">
            <a target="_blank" href="https://riberasalud.com/area-del-corazon/consejos/">
              <div class="btn">
                <div class="left">
                  <div class=" item white" ><div class="splita">Descubre más consejos</div></div>
                </div>
                <div class="right">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.328 16.328"><g id="Capa_2" data-name="Capa 2"><g id="Capa_1-2" data-name="Capa 1"><path class="cls-1" d="M15.855,0H5.823a.473.473,0,1,0,0,.946h8.89L.139,15.52a.473.473,0,0,0,.668.669L15.382,1.614V10.5a.473.473,0,1,0,.946,0V.473A.473.473,0,0,0,15.855,0Z"></path></g></g></svg>
                </div>
              </div>
            </a>            
          </div>
          <div class="minitext padd-t-2" >
            <p>Avalado por profesionales del <a target="_blank" href="https://riberasalud.com/area-del-corazon/">Área del Corazón</a> del grupo sanitario Ribera</p>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>


<div class="section3 wbg lines padd-t-4 padd-b-4" id="join">
  <div class="wrapper container aligncenter">
    <div class="wrapper">
      <div class="row">
        <div class="col">
          <div class="wrapper m-w-800">
            <div class="pretitle padd-b-1">Únete</div>
            <h2 class="grey">Toca al ritmo de un corazón arrítmico</h2>  
            <p class="m-w-550 auto padd-t-2 padd-b-2">
              ¿Eres músico? ¿Tocas algún instrumento?
              <br/>
              Envíanos tu vídeo improvisando al ritmo del metrónomo y súmate a la iniciativa.
            </p>

            <div class="row padd-t-4 padd-m-t-0">
              <div class="col mar-m-b-1  ">
                <div class="containerbuton linksplitscrolla aligncenter scaled">
                  <a download="Metronomo_RitmosdeVida" href="assets/RitmosDeVida_metronomo.mp3">
                    <div class="btn btn-2">
                      <div class="left">
                        <div class=" item white" ><div class="splita">Descarga el metrónomo</div></div>
                      </div>
                      <div class="right flecha-up">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.328 16.328"><g id="Capa_2" data-name="Capa 2"><g id="Capa_1-2" data-name="Capa 1"><path class="cls-1" d="M15.855,0H5.823a.473.473,0,1,0,0,.946h8.89L.139,15.52a.473.473,0,0,0,.668.669L15.382,1.614V10.5a.473.473,0,1,0,.946,0V.473A.473.473,0,0,0,15.855,0Z"></path></g></g></svg>
                      </div>
                    </div>
                  </a>            
                </div>
              </div>

              <div class="col ">
                <div class="containerbuton linksplitscrolla aligncenter scaled">
                  <a href="mailto:comunicacion@riberasalud.es">
                    <div class="btn btn-3">
                      <div class="left">
                        <div class=" item " ><div class="splita">Envíanos tu vídeo</div></div>
                      </div>
                      <div class="right flecha-down">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.328 16.328"><g id="Capa_2" data-name="Capa 2"><g id="Capa_1-2" data-name="Capa 1"><path class="cls-1" d="M15.855,0H5.823a.473.473,0,1,0,0,.946h8.89L.139,15.52a.473.473,0,0,0,.668.669L15.382,1.614V10.5a.473.473,0,1,0,.946,0V.473A.473.473,0,0,0,15.855,0Z"></path></g></g></svg>
                      </div>
                    </div>
                  </a>            
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      



      <div class="row padd-t-4 padd-m-t-2">
        <div class="col ">
          <div class="section2_b relative">
            <div class="wrapper">
              <div class="box-image mainvideo minivideo mainvideo2 opacity0">
                <div class="over overv1"></div>
                <main>
                      <a onclick="videolayer('https:/\/\www.youtube.com/embed/JE0vI_HtS-4')" class="magnetic-wrap size1 an02 ">
                        <div class="js-magnetic-area magnetic-size"></div>
                        <div class="js-magnetic-content">
                          <div class="playbutton playbutton-small">
                            <div class="svgwrapper">
                              <svg class="arrow01" width="70px" height="70px" version="1.1" viewBox="0 0 600 580" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="m592.74 280-485.48-280v560z"/></svg>
                            </div>
                          </div>
                        </div>
                      </a>
                </main>
              </div>
            </div>
          </div>
          <div class="musico">
            <p><i>Urko López</i> <br> <span>Bajista en Los Candeleros</span></p>
          </div>
        </div>

        <div class="col ">
          <div class="section2_b relative">
            <div class="wrapper">
              <div class="box-image mainvideo minivideo mainvideo3 opacity0">
                <div class="over overv1"></div>
                <main>
                      <a onclick="videolayer('https:/\/\www.youtube.com/embed/_19fE8ppo5Y')" class="magnetic-wrap size1 an02 ">
                        <div class="js-magnetic-area magnetic-size"></div>
                        <div class="js-magnetic-content">
                          <div class="playbutton playbutton-small">
                            <div class="svgwrapper">
                              <svg class="arrow01" width="70px" height="70px" version="1.1" viewBox="0 0 600 580" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="m592.74 280-485.48-280v560z"/></svg>
                            </div>
                          </div>
                        </div>
                      </a>
                </main>
              </div>
            </div>
          </div>
          <div class="musico">
            <p><i>Nacho Mur</i> <br> <span>Guitarrista en La M.O.D.A.</span></p>
          </div>
        </div>
      </div>


      <div class="minitext padd-t-1 " >
        <p><a target="_blank" href="https://www.youtube.com/playlist?list=PLKvWwJOrR7hS-eo8xd3GhfICMOYeJkaLc">Descubre todos los artistas</a></p>
      </div>

    </div>
  </div>
</div>


<div class="section5 wbg lines padd-t-4 padd-b-4" id="exposition">
  <div class="wrapper container aligncenter">
    <div class="wrapper">
      <div class="row">
        <div class="col">
          <div class="wrapper m-w-550">
            <div class="pretitle padd-b-1 white">Exposiciones</div>
            <h2 class="white">Descubre el metrónomo</h2>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>




<div class="section6 wbg lines padd-t-2 padd-b-4">
  <div class="wrapper container aligncenter">
    <div class="wrapper">
      <div class="row">
        <div class="col">
          <div class="wrapper m-w-550 auto padd-t-2 padd-b-2">
            <p>
              A lo largo de los próximos meses, Ribera expondrá el metrónomo en
              los halls de sus diferentes hospitales de manera itinerante. También
              podrán hacerlo aquellos hospitales que no sean del grupo y que
              quieran sumarse a la iniciativa.
              <br/><br/>
              Además, el grupo organizará diferentes jornadas de concienciación
              con asociaciones de pacientes de sus hospitales para dar a
              conocer la iniciativa.
            </p>

          </div>
        </div>
      </div>

      <div class="row contacts padd-t-3 padd-m-t-1">
        <div class="directors row rows01 appearOpacity appearOpacity03">
          <div class="wrapper flick02">
              <div class="director overVideoReel relative">


                <a href="https://riberasalud.com/area-del-corazon/eventos/" target="_blank" class=" row verticalalign calendario-item linksplitscrolla ">
                  <div class="calendario-item-content">
                    <div><p class="dir white">Hospital Universitario de Torrejón</p></div>
                    <div class="containerbuton  "><div class="btn btn-calendario"><div class="item white"><p class="fecha-short white"> 30 enero - 01 marzo</p></div></div></div>
                    <div><p class="txtcontainer fecha white splita">Ver más eventos</p></div>

                  </div>
                </a>

                <a class=" row verticalalign calendario-item  calendario-disabled-blur nopointer">
                  <div class="calendario-item-content ">
                    <div><p class="dir white">Hospital de Vinalopó</p></div>
                    <div class="containerbuton  "><div class="btn btn-calendario"><div class="item white"><p class="fecha-short white"> 30 enero - 01 marzo</p></div></div></div>
                    <div><p class="txtcontainer fecha white splita">Ver más eventos</p></div>
                  </div>
                </a>

                <a  class=" row verticalalign calendario-item calendario-disabled-blur nopointer">
                  <div class="calendario-item-content">
                    <div><p class="dir white">Hospital de Dènia</p></div>
                    <div class="containerbuton  "><div class="btn btn-calendario"><div class="item white"><p class="fecha-short white"> 30 enero - 01 marzo</p></div></div></div>
                    <div><p class="txtcontainer fecha white splita">Ver más eventos</p></div>
                  </div>
                </a>

                <a  class=" row verticalalign calendario-item calendario-disabled-blur nopointer">
                  <div class="calendario-item-content">
                    <div><p class="dir white">Hospital Ribera Povisa</p></div>
                    <div class="containerbuton  "><div class="btn btn-calendario"><div class="item white"><p class="fecha-short white"> 30 enero - 01 marzo</p></div></div></div>
                    <div><p class="txtcontainer fecha white splita">Ver más eventos</p></div>
                  </div>
                </a>

                  <div class="nodesk padd-m-t-2">
                    <p>¿Eres un hospital y te gustaría exponer el metrónomo de Ritmos de Vida? </p>
                  </div>


                  <div class="containerbuton linksplitscrolla aligncenter contactar-hospital scaled">
                    <a href="mailto:comunicacion@riberasalud.es">
                      <div class="btn">
                        <div class="left">
                          <div class=" item white" >
                            <div class="splita nomob">¿Eres un hospital y te gustaría exponer el metrónomo de Ritmos de Vida? <span style="text-decoration: underline;">Ponte en contacto con nosotros</span></div>
                            <div class="splita nodesk">Contacta con nosotros</div>
                          </div>
                        </div>
                        <div class="right">
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.328 16.328"><g id="Capa_2" data-name="Capa 2"><g id="Capa_1-2" data-name="Capa 1"><path class="cls-1" d="M15.855,0H5.823a.473.473,0,1,0,0,.946h8.89L.139,15.52a.473.473,0,0,0,.668.669L15.382,1.614V10.5a.473.473,0,1,0,.946,0V.473A.473.473,0,0,0,15.855,0Z"></path></g></g></svg>
                        </div>
                      </div>
                    </a>            
                  </div>

              </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>




<app-footer></app-footer>

</div>


 -->


 <!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * * * The content below * * * * * * * * * * * -->
<!-- * * * * * * * * * * is only a placeholder * * * * * * * * * * -->
<!-- * * * * * * * * * * and can be replaced. * * * * * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * Delete the template below * * * * * * * * * * -->
<!-- * * * * * * * to get started with your project! * * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->

<app-nav></app-nav>
<router-outlet></router-outlet>
